import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { GoogleMap, useJsApiLoader, Marker, InfoWindowF } from '@react-google-maps/api';
import MunicipalidadHeader from '../components/Header/MunicipalidadHeader';
import { listPosiciones } from '@/api/municipalidadAPI';
import './VehiculosView.css';

const containerStyle = {
  width: '100%',
  height: '600px',
};

const center = {
  lat: -40.762459,
  lng: -71.644785,
};

const VehiculosView = () => {
  const [zoom, setZoom] = useState(14);
  const [map, setMap] = useState(null);
  const [posicionesList, setPosiciones] = useState(null);
  const [markers, setMarkers] = useState(null);
  const [activeMarker, setActiveMarker] = useState(null);

  console.log(map);

  const handleActiveMarker = (m) => {
    if (m === activeMarker) {
      return;
    }
    setActiveMarker(m);
  };

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: 'AIzaSyAXIGBddh8X3LajYuhYQcEI0s61rN7lOvc',
  });

  const onLoad = React.useCallback(function callback(map) {
    // This is just an example of getting and using the map instance!!! don't just blindly copy!
    const bounds = new window.google.maps.LatLngBounds(center);
    map.fitBounds(bounds);
    map.setZoom(15);

    setMap(map);
  }, []);

  const onUnmount = React.useCallback(function callback(map) {
    console.log(map);
    setMap(null);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setZoom(15);
    }, 300);

    listPosiciones()
      .then((response) => {
        setPosiciones(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    buildMakers();
  }, posicionesList);

  function buildMakers() {
    if (posicionesList != null) {
      let markersTemp = [];
      for (let i = 0; i < posicionesList.length; i++) {
        let item = posicionesList[i];
        let marker = {
          position: {
            lat: Number(item.latitud),
            lng: Number(item.longitud),
          },
          title: item.alias,
          icon: item.icono,
        };
        markersTemp.push(marker);
      }
      setMarkers(markersTemp);
    }
  }

  const options = {
    minZoom: 4,
    maxZoom: 18,
  };

  return (
    <>
      <MunicipalidadHeader tipo="Ciudadano" title="Seguimiento de Vehículos"></MunicipalidadHeader>
      <Container className="content pagina-interna">
        <div className="mapa-title">
          En el mapa se muestran solamente los vehículos recolectores de residuos y las máquinas
          viales afectadas a la reparación de calles.
        </div>
        {isLoaded != '' && (
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={zoom}
            options={options}
            onLoad={onLoad}
            onUnmount={onUnmount}
            onClick={() => setActiveMarker(null)}
          >
            {markers !== null &&
              markers.length > 0 &&
              markers.map((item, idx) => (
                <Marker
                  key={idx}
                  position={item.position}
                  icon={item.icon}
                  title={item.title}
                  onClick={() => handleActiveMarker(idx)}
                >
                  {activeMarker === idx ? (
                    <InfoWindowF onCloseClick={() => setActiveMarker(null)}>
                      <div>{item.title}</div>
                    </InfoWindowF>
                  ) : null}
                </Marker>
              ))}
            <></>
          </GoogleMap>
        )}
      </Container>
    </>
  );
};

export default React.memo(VehiculosView);
